import $ from "jquery";

import Controller from './Controller/Controller';
import './Controller/PageController';

import "./Extensions/HiFilemanagement/app";
import "./Extensions/IgGallery/app";
import "./Extensions/IgGraf/app";
import "./Extensions/IgHeaderslider/app";
import "./Extensions/IgLocation/app";
import "./Extensions/IgTankAdvisor/app";
import "./Extensions/IgTeaser/app";

$('[data-equalizer]').on('postequalized.zf.equalizer', (e) => {
	$(e.currentTarget).addClass('equalized');
});

// Initialize Foundation JavaScript
$(document).foundation();

$(document).ready(function () {


	// Initialize Fancybox links
	$('a[class*=fancybox],a[class*=lightbox],a[rel*=fancybox]').fancybox({
		live: false,
		toolbar: false,
		arrows: false,
		infobar : false,
		buttons : false,
		autoDimensions: true,
		width: 984,
		closeClick  : false,
		afterLoad: function (instance, current) {
			//navigation Arrow
			if (instance.group.length > 1 && current.$content) {
				current.$content.append('<a data-fancybox-next class="button-next custom-fancybox-button" href="javascript:;"></a><a data-fancybox-prev class="button-previous custom-fancybox-button" href="javascript:;"></a>');
			}
			//close button
			current.$content.append('<a data-fancybox-close class="button-close" href="javascript:;"></a>');

      if (current.$thumb) {
        //download link
        let slicedTitle = current.$thumb['prevObject'][0].getAttribute('title');
        current.$content.append('<a class="dl" href="' + current.$thumb['prevObject'][0].getAttribute('data-big') + '" download>' + slicedTitle + '</a>');
      }

		},
		helpers: {
			title: {
				type: "inside"
			}
		}
	});

	$('a[class*=presse-fancybox]').fancybox({
		live: false,
		toolbar: false,
		arrows: false,
		infobar : false,
		buttons : false,
		autoDimensions: true,
		width: 984,
		closeClick  : false,
		afterLoad: function (instance, current) {
			//navigation Arrow
			if (instance.group.length > 1 && current.$content) {
				current.$content.append('<a data-fancybox-next class="button-next custom-fancybox-button" href="javascript:;"></a><a data-fancybox-prev class="button-previous custom-fancybox-button" href="javascript:;"></a>');
			}
			//close button
			current.$content.append('<a data-fancybox-close class="button-close" href="javascript:;"></a>');

      if (current.$thumb) {
        //presse links
        let links = current.$thumb['prevObject'][0].getAttribute('data-links');
        let linkJson = JSON.parse(links)
        console.log(linkJson);
        console.log(linkJson[0]);

        //download link
        let slicedTitle = current.$thumb['prevObject'][0].getAttribute('title');
        current.$content.append('<a class="dl press-release" href="' + current.$thumb['prevObject'][0].getAttribute('data-big') + '" download>' + slicedTitle + '</a>');
        current.$content.append('<a class="pr press-release" href="' + window.location.origin + linkJson[0].href + '">' + linkJson[0].name + '</a>');
      }

		},
		helpers: {
			title: {
				type: "inside"
			}
		}
	});

	// Initialize jquery.lazy - http://jquery.eisbehr.de/lazy/
	$('.lazyload-placeholder').Lazy({
		threshold: 300
	});

	// Add current search parameter to url to allow tracking with googleAnalytics
	// See https://typo3blogger.de/suchbegriffe-in-google-analytics/
	// Important: Add parameter "s" to TYPO3 [FE][cacheHash][excludedParameters]
	$('#search_form').on('submit', function (e) {
		$(e.target).attr('action', $(e.target).attr('action') + '?s=' + encodeURIComponent($(e.target).find('#search_input').val()));
	});

	// Initialize Controller
	Controller.initialize();
});

$(window).on('load', () => {
	Controller.onLoad();
});

$(window).on('scroll', () => {
	Controller.onScroll();
});
